import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import projectUpdaters from '@/api/updaters/content-studio/project';
import {CONTENT_LAB, FOLDERS, PROJECTS} from '../../consts';

export function useApplyRephrase() {
  return useMutation({
    mutationFn: projectUpdaters.applyRephrase,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [CONTENT_LAB, PROJECTS]});
      queryClient.invalidateQueries({queryKey: [CONTENT_LAB, FOLDERS]});
    },
  });
}

export default useApplyRephrase;
